import type { FaireProductEntity } from "../../entity_types/product";

export const p_cv64fder2f: FaireProductEntity = {
  token: "p_cv64fder2f",
  type: "product",
  name: 'Thin 100% Pure Beeswax Candles (7 Pack) - 12" Tall, Natural',
  brandToken: "b_d72c56fe",
  brandName: "54 Celsius",
  imageUrl:
    "https://cdn.faire.com/fastly/c45847a08828c900a7c2cb4fda8b4a49fda22ae49c762dd17108740871f9f014.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ad2dc873eb6e5aabbce94084126fec1d59ae898e457381d16ea719fe5a03f4cb.jpeg",
    "https://cdn.faire.com/fastly/87248fa40f85f59d338d9a68f5cff027b5109a4ec9fdb43dea93982b5fb000bd.jpeg",
  ],
  priceDollars: 11,
  description:
    "A pack of seven 100% pure beeswax candles with a braided cotton wick. Each candle is hand dipped. These slender elegant candles are perfect for dinners and entertaining. They have a lovely light beeswax smell. They pair perfectly with our XS Brass Candle Holders shown in the photo (to be ordered separately).\n\n• Diameter: 3/8”, length: 12”\n• Burning time: 2.5 hours\n• Bundle contains 7 candles\n• Made in China\n\nThese are a natural handmade product. Thin beeswax candles tend to bend slightly, but you can gently bend them back into shape. Some uneven or natural marks may occur during the production process. Over time, 100% beeswax will develop a white film over the candles. This is a natural occurrence, similar to the film on dark chocolate and 100% soy wax. It's similar to tarnishing that occurs on brass. If you would like to remove it, simply wipe the candles with a dry cloth. Otherwise, embrace nature and leave it as part of the beauty of 100% beeswax.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:42.062Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
